import { CheckCircle2, Circle } from 'lucide-react'
import { toUiDealStage } from '@/adapters/deals'
import {
  AUTOMATIC_ENTRADA_STEP_KEYS,
  ENTRADA_STEP_DESCRIPTIONS,
  ENTRADA_STEP_LABELS,
  type EntradaSteps,
} from '@/components/Gestores/gestorClienteEntradaConfig'
import { getStageLabel } from '@/components/Deals/deals-constants'
import { cn } from '@/utils/cn'

type Props = {
  dealEtapa: string
  steps: EntradaSteps
}

export function GestorEntradaKanbanSync({ dealEtapa, steps }: Props) {
  const stageLabel = getStageLabel(toUiDealStage(dealEtapa))

  return (
    <section className='glass-card rounded-xl border border-white/[0.06] p-4'>
      <p className='text-xs font-semibold uppercase tracking-wider text-text-muted'>
        Kanban comercial
      </p>
      <p className='mt-1 text-sm text-text-primary'>
        Etapa atual do deal: <span className='font-semibold'>{stageLabel}</span>
      </p>
      <ul className='mt-4 space-y-2'>
        {AUTOMATIC_ENTRADA_STEP_KEYS.map((stepKey) => {
          const step = steps[stepKey]
          return (
            <li key={stepKey} className='flex items-start gap-2.5 text-sm'>
              {step.done ? (
                <CheckCircle2 size={16} className='mt-0.5 shrink-0 text-emerald-500' />
              ) : (
                <Circle size={16} className='mt-0.5 shrink-0 text-text-muted' />
              )}
              <div className='min-w-0'>
                <p className={cn('font-medium', step.done ? 'text-text-primary' : 'text-text-muted')}>
                  {ENTRADA_STEP_LABELS[stepKey]}
                </p>
                <p className='text-xs text-text-muted'>{ENTRADA_STEP_DESCRIPTIONS[stepKey]}</p>
              </div>
            </li>
          )
        })}
      </ul>
      <p className='mt-3 text-[11px] leading-relaxed text-text-muted'>
        Handover e grupo WhatsApp são marcados automaticamente quando o deal avança nas colunas
        Handover e Contrato Assinado do kanban comercial.
      </p>
    </section>
  )
}
